import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Breadcrumb2Container } from "../../breadcrumb2/Breadcrumb2Container";
import { DropdownExibicaoItens, ItemDropdown } from "../../dropdown-exibicao-itens/DropdownExibicaoItens";
import * as R from 'ramda';
import { DomainDataPendenciaCliente } from "../../../types/cliente/DomainDataPendenciaCliente";
import { OrcamentoEmAberto, OrcamentoEmAbertoForm } from "./orcamentoEmAberto/OrcamentoEmAberto";
import { VendedorRelacionado } from "./vendedorRelacionado/vendedorRelacionado";
import { PendenciaAreaDeVenda } from "./areaDeVenda/PendenciaAreaDeVenda";
import { ClienteComLimiteCreditoBloqueado } from './ClienteComLimiteCreditoBloqueado/ClienteComLimiteCreditoBloqueado';
const estilos = require('./pendencia-cliente.module.scss').default;

export type PendenciaClienteProps = {
    onVoltar: () => void;
    domain: DomainDataPendenciaCliente;
    valoresFormularioOrcamentoEmAberto: OrcamentoEmAbertoForm;
    processando?: boolean;
    onFiltrarOrcamentosEmAberto: (values: OrcamentoEmAbertoForm) => void;
    onAlterarPaginaOrcamentosEmAberto: (filtros: OrcamentoEmAbertoForm) => void;
    onAlterarSenhaVendedorRelacionado: (senha: string) => void;
    onAlterarSenhaOrcamentoEmAberto: (senha: string) => void;
    onAlterarsenhaClienteComLimiteCreditoBloqueado: (senha: string) => void; // 436006
    onAlterarSenhaAreaDeVenda: (senha: string) => void;
    onOk: () => void;
};

export const PendenciaCliente = React.memo((props: PendenciaClienteProps) => {
    const [itensDropdown, setItensDropdown] = useState<ItemDropdown[]>([]);

    const atualizarItensDropdown = useCallback(() => {
        const novosItens: ItemDropdown[] = [];

        if (props.domain?.ExistemPedidosEmAbertoClienteException) {
            novosItens.push({
                titulo: "Orçamentos em Aberto",
                componenteExibicao: (
                    <OrcamentoEmAberto
                        onAlterarPagina={props.onAlterarPaginaOrcamentosEmAberto}
                        paginaAtual={props.domain.ExistemPedidosEmAbertoClienteException?.Pedidos?.ActualPage ?? 0}
                        pageCount={props.domain.ExistemPedidosEmAbertoClienteException?.Pedidos?.PageCount}
                        processando={props.processando}
                        onFiltrar={props.onFiltrarOrcamentosEmAberto}
                        valoresFormulario={props.valoresFormularioOrcamentoEmAberto}
                        dados={props.domain.ExistemPedidosEmAbertoClienteException?.Pedidos?.Entities}
                        onChangeSenha={props.onAlterarSenhaOrcamentoEmAberto}
                        exibirSenha={props.domain.ExistemPedidosEmAbertoClienteException.ExigirSenha}
                    />
                ),
                exibirDropdown: true,
            });
        }

        if (props.domain?.VendedorRelacionadoClienteDiferenteVendedorLogadoException) {
            novosItens.push({
                titulo: "Vendedor Relacionado",
                componenteExibicao: (
                    <VendedorRelacionado
                        onChangeSenha={props.onAlterarSenhaVendedorRelacionado}
                    />
                ),
                exibirDropdown: true,
            });
        }

        if (props.domain?.ClienteSemAreaDeVendaException) {
            novosItens.push({
                titulo: "Área de Venda",
                componenteExibicao: (
                    <PendenciaAreaDeVenda
                        onChangeSenha={props.onAlterarSenhaAreaDeVenda}
                    />
                ),
                exibirDropdown: true,
            });
        }

        if (props.domain?.ClienteComLimiteCreditoBloqueadoException) {
            novosItens.push({
                titulo: "Cliente Com Limite Crédito Bloqueado",
                componenteExibicao: (
                    <ClienteComLimiteCreditoBloqueado
                        onChangeSenha={props.onAlterarsenhaClienteComLimiteCreditoBloqueado}
                        // Enter no campo de senha = clicar em Ok. Sai `undefined` enquanto
                        // `processando`, pelo mesmo motivo do `disabled` do botão: não deixar
                        // disparar duas vezes a mesma confirmação.
                        onConfirmar={props.processando ? undefined : props.onOk}
                    />
                ),
                exibirDropdown: true,
            });
        }

        setItensDropdown(novosItens);
    }, [props.domain, props.onAlterarPaginaOrcamentosEmAberto, props.onFiltrarOrcamentosEmAberto, props.valoresFormularioOrcamentoEmAberto, props.onAlterarSenhaOrcamentoEmAberto, props.onAlterarSenhaVendedorRelacionado, props.onAlterarSenhaAreaDeVenda, props.onAlterarsenhaClienteComLimiteCreditoBloqueado, props.onOk, props.processando]);

    useEffect(() => {
        atualizarItensDropdown();
    }, [atualizarItensDropdown]);

    const alterarExibicaoItem = useCallback((item: ItemDropdown) => {
        setItensDropdown(prevItens =>
            prevItens.map(prevItem => ({
                ...prevItem,
                exibirDropdown: prevItem.titulo === item.titulo ? !prevItem.exibirDropdown : false,
            }))
        );
    }, []);

    const botoes = useMemo(() => (
        <>
            <button
                onClick={props.onOk}
                className={estilos.button}
                disabled={props.processando}
                style={{ marginLeft: "8px" }}
                id="PendenciaCliente_BotaoOk"
                key="PendenciaCliente_BotaoOk"
            >
                Ok
            </button>
            <button
                onClick={props.onVoltar}
                className={estilos.button}
                disabled={props.processando}
                style={{ marginLeft: "8px" }}
                id="PendenciaCliente_BotaoCancelar"
                key="PendenciaCliente_BotaoCancelar"
            >
                Cancelar
            </button>
        </>
    ), [props.onOk, props.onVoltar, props.processando]);

    return (
        <>
            <Breadcrumb2Container
                passos={[]}
                exibirBotaoLimpar={false}
                id="PendenciaClienteContainer"
                key="PendenciaClienteContainer"
                onBotaoVoltarClicado={props.onVoltar}
                exibirBotaoVoltar
            />
            <DropdownExibicaoItens
                itens={itensDropdown}
                onClickItem={alterarExibicaoItem}
            />
            {botoes}
            <section style={{ marginBottom: "100px" }} />
        </>
    );
});